export const transactions = {
  A: 'Debit Note',
  B: 'Credit Note',
  Y: 'Receipt',
  Z: 'Payment'
}

export const tranTypes = {
  W: 'Debit Note',
  X: 'Credit Note',
  Y: 'Receipt',
  Z: 'Payment Voucher'
}

export const paymentMethods = {
  C: 'Cheque',
  G: 'GIRO'
}

export const GSTIO = {
  B: '',
  I: 'Input GST',
  O: 'Output GST'
}

export const riTypes = {
  C: 'Coinsurance',
  D: 'Statutory',
  F: 'Facultative',
  T: 'Treaty',
  W: 'Quota Share',
  X: 'Excess of Loss'
}

export const proplXol = {
  P: 'Proportional',
  X: 'XOL'
}

export const settCode = {
  N: 'Normal',
  P: 'Priority',
  A: 'Cash Call (Immediate)'
}

export const prtOffSetLtr = {
  N: 'No',
  I: 'Immediate',
  L: 'Later'
}

export const grossNet = {
  G: 'Gross',
  N: 'Net'
}

export const riskCurrency = {
  L: 'Local',
  O: 'Original'
}

export const riskAccumulateBased = {
  Gross: 'Gross Sum Insured',
  EML: 'EML'
}

export const riskFilterBy = {
  Rel: 'Released transactions only',
  Unrel: 'Include unreleased transactions',
  Confirm: 'Confirmed Blocks',
  Unconfirm: 'Unconfirmed Blocks'
}

export const printDocOpts = {
  I: 'Immediately',
  L: 'Later',
  N: 'No'
}

export const roleLvl = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: '10'
}

export const modId = {
  1: '1 - Underwriting',
  2: '2 - Claims',
  3: '3 - Accounting'
}

export const statusCode = {
  'C': 'C - Completed',
  'N': 'N - New',
  'FP': 'FP - Fail to Process',
  'F': 'F - Fail to Generate',
  'P': 'P - Processing'
}

export const labels = {
  Password: 'Password'
}
